import { useEffect, useState } from 'react';
import { Image } from './FeedbackTable';
import { StickerParams, useGetSticker } from 'hooks/business/im/sticker';

export const OperateLogSticker = (props: StickerParams) => {
  const { channel, region, sid, pid } = props;
  const [ossStickerAddress, setOssStickerAddress] = useState<string | undefined>();

  const getSticker = useGetSticker();

  useEffect(() => {
    getSticker({
      channel,
      region,
      sid,
      pid,
    }).then((sticker) => {
      setOssStickerAddress(sticker?.ossStickerAddress);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel, region, sid, pid]);

  return ossStickerAddress ? (
    <div className="mb-[12px]">
      <Image preview={false} height="120px" src={ossStickerAddress} />
    </div>
  ) : null;
};
